/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { ApiResult } from "./ApiResult";
import {
    ApiResultFromJSON,
    ApiResultFromJSONTyped,
    ApiResultToJSON,
} from "./ApiResult";

/**
 *
 * @export
 * @interface NewDeviceFaultTicketPreview
 */
export interface NewDeviceFaultTicketPreview {
    /**
     *
     * @type {string}
     * @memberof NewDeviceFaultTicketPreview
     */
    summary?: string;
    /**
     *
     * @type {string}
     * @memberof NewDeviceFaultTicketPreview
     */
    description?: string;
    /**
     *
     * @type {boolean}
     * @memberof NewDeviceFaultTicketPreview
     */
    userAccountFound?: boolean;
    /**
     *
     * @type {string}
     * @memberof NewDeviceFaultTicketPreview
     */
    createUserAccountUrl?: string;
    /**
     *
     * @type {string}
     * @memberof NewDeviceFaultTicketPreview
     */
    error?: string;
    /**
     *
     * @type {ApiResult}
     * @memberof NewDeviceFaultTicketPreview
     */
    apiResult?: ApiResult;
}

/**
 * Check if a given object implements the NewDeviceFaultTicketPreview interface.
 */
export function instanceOfNewDeviceFaultTicketPreview(
    value: object,
): value is NewDeviceFaultTicketPreview {
    return true;
}

export function NewDeviceFaultTicketPreviewFromJSON(
    json: any,
): NewDeviceFaultTicketPreview {
    return NewDeviceFaultTicketPreviewFromJSONTyped(json, false);
}

export function NewDeviceFaultTicketPreviewFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): NewDeviceFaultTicketPreview {
    if (json == null) {
        return json;
    }
    return {
        summary: json["summary"] == null ? undefined : json["summary"],
        description:
            json["description"] == null ? undefined : json["description"],
        userAccountFound:
            json["userAccountFound"] == null
                ? undefined
                : json["userAccountFound"],
        createUserAccountUrl:
            json["createUserAccountUrl"] == null
                ? undefined
                : json["createUserAccountUrl"],
        error: json["error"] == null ? undefined : json["error"],
        apiResult:
            json["apiResult"] == null
                ? undefined
                : ApiResultFromJSON(json["apiResult"]),
    };
}

export function NewDeviceFaultTicketPreviewToJSON(
    value?: NewDeviceFaultTicketPreview | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        summary: value["summary"],
        description: value["description"],
        userAccountFound: value["userAccountFound"],
        createUserAccountUrl: value["createUserAccountUrl"],
        error: value["error"],
        apiResult: ApiResultToJSON(value["apiResult"]),
    };
}
